module.exports = __webpack_public_path__ + "static/sportsconnect-02969c52d84fd065b05e9fcf2b4e0690.jpg";